var map = {
	"./#03CEA4/yesOrNoEle.svg": "eca0",
	"./#3777FF/yesOrNoEle.svg": "da60",
	"./#EE964B/yesOrNoEle.svg": "0409",
	"./#F754A2/yesOrNoEle.svg": "d772",
	"./#FF495C/yesOrNoEle.svg": "decf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4640";